import React from "react";
import PropTypes from "prop-types";
import {Icon, Avatar} from "antd";
import {setIcon} from "../../services/setIcon";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import {SET_MODAL} from "../../constants";
import Btn from "components/common/btn";
import BlueCardImage from "assets/img/sandos4UCards/Blue.png";
import GoldCardImage from "assets/img/sandos4UCards/Gold.png";
import PlatinumCardImage from "assets/img/sandos4UCards/Platinum.png";
import BlackCardImage from "assets/img/sandos4UCards/Black.png";
import AvatarS4u from '../../assets/img/AvatarS4u.png';

// Member updated coins information MUST be obtained from "membershipInfo" info
// If performing actions that update the coins, then reload this information to keep it in sync!!
const getNumberOfCoins = (membershipInfo) => {
  return membershipInfo?.memberPoints?.totalPoints || 0;
};

const AvatarUser = ({ src }) => <Avatar shape="circle" src={src}/>;

const MemberCoins = ({ membershipInfo, context, member }) => {
  const cardImages = {
    1: BlueCardImage,
    2: GoldCardImage,
    3: PlatinumCardImage,
    4: BlackCardImage,
  };
  const cardImage = member? cardImages[member.levelId]: BlueCardImage;

  const coins = getNumberOfCoins(membershipInfo);
  if (coins < 0) {
    return null;
  }
  return (
    <div className="flex items-center">
      <div className="text-white text-right mr-2">
        <span className="block text-2xl font-bold">{coins}</span>
        <span style={{
          fontSize: "12px"
        }}
        
        className="block text-sm">{context.t("Coins")}</span>
      </div>
      <img
        src={cardImage}
        alt="Loyalty Card"
        className="navbar-card-image"
      />
    </div>
  );
}

const Member = ({ member, membershipInfo, context, loy3Profile }) => {
  const memberLevel = member.memberShipName || '';
  const memberAvatar = member.profilePic || member.avatar || AvatarS4u;
  const hasName = member.firstName || member.lastName;
  const userName = hasName
    ? `${member.firstName} ${member.lastName}`
    : context.t("{memberLevel} member", {memberLevel});

  const memberCoins = <MemberCoins membershipInfo={membershipInfo} context={context} member={member} />;
  return (
    <div className="w-64 pb-4">
      <div className="flex items-center">
        {memberAvatar &&
        <div className="mr-2">
          <AvatarUser src={memberAvatar}/>
        </div>}
        <span>{userName}</span>
      </div>
      <div className="text-primary text-lg text-center">
        {context.t('{level} Level', { level: memberLevel })}
        {/* {memberCoins && <span>, {memberCoins}</span>} */}
      </div>
    </div>
  );
};

const UserLoggedIcon = ({ member, membershipInfo, context, loy3Profile }) => {
  const memberAvatar = member.profilePic || member.avatar || AvatarS4u;
  const memberLevel = member && member.memberShipName ? member.memberShipName.toLowerCase() : "";
  const memberCoins = <MemberCoins membershipInfo={membershipInfo} context={context} member={member} />;
  const firstName = member?.firstName
  return (
    <div className={`userDetails ${memberLevel}`}>
      <div className="flex items-center gap-4">
        {/* Greeting + Avatar */}
        <div className="flex items-center gap-3">
          <div className="text-white text-sm">
            {context.t("Hi")} {firstName}!
          </div>
          {memberAvatar && <AvatarUser src={memberAvatar} />}
        </div>

        {/* Coins + Card */}
        {memberCoins && (
          <div className="userDetails__coins text-xs text-black">
            {memberCoins}
          </div>
        )}
      </div>
    </div>
  );
};

const UserNotLogged = ({context, closeNavMenu}) => {
  const dispatch = useDispatch();
  const showLogin = () => dispatch({ type: SET_MODAL, key: "login", val: true });
  return (
    <div className="flex items-center bg-white mt-1 mx-1 md:mx-0 md:shadow-md rounded-sm">
      <Btn
        className="font-semibold text-orange-primary px-3 py-2 whitespace-no-wrap"
        onClick={() => { showLogin(); closeNavMenu() }}>
        {context.t("Log-in")}
      </Btn>
      {context.t("or")}
      <Link
        to="/register"
        className="font-semibold text-orange-primary px-3 py-2"
        onClick={closeNavMenu}
      >
        {context.t("Register")}
      </Link>
    </div>
  );
};

function UserMenu({type, member, membershipInfo, isMember, dispatch, closeNavMenu, loy3Profile}, context) {
  if (isMember) {
    return (
      <div className="sl-dropdown mx-4">
        <Link
          to="/profile"
          onClick={closeNavMenu}
        >
          <UserLoggedIcon
            member={member}
            membershipInfo={membershipInfo}
            context={context}
            loy3Profile={loy3Profile}
          />
        </Link>
        <div className="sl-dropdown__content hidden md:block">
          <div className="text-gray-900 bg-white md:shadow-md rounded-md p-2  mt-4 overflow-hidden">
            <Member
              member={member}
              membershipInfo={membershipInfo}
              context={context}
              loy3Profile={loy3Profile}
            />
            <Link
              to="/logout"
              className="bg-primary text-white flex justify-between items-center -mx-2 -mb-2 p-2 "
              onClick={closeNavMenu}
            >
              {context.t("Log out")}
              <Icon component={setIcon("logout")} className="ml-2"/>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const showLogin = () => dispatch({ type: SET_MODAL, key: "login", val: true });
  return (
    <div className="sl-dropdown--login">
      <Btn className="btn btn-sqr btn-outline-white uppercase font-normal hidden md:inline-block"
           onClick={() => showLogin()}>
        {context.t("Register or login")}
      </Btn>
      <div className="sl-dropdown__content">
        <UserNotLogged closeNavMenu={closeNavMenu} context={context}/>
      </div>
    </div>
  );
}

UserMenu.contextTypes = {
  t: PropTypes.func.isRequired,
};

UserMenu.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default UserMenu;
